import React from 'react'
import { useImmer } from 'use-immer'

// import * as NmiForm from './NmiForm'
import { Packages } from './Packages'
import { generateErrorMessage, calculatePackages } from './utils/packages'
// import collectJs_handleResponse_implementation from '@newswebsiteapp/shared/react/utils/collectJs_handleResponse_implementation'
import { useNmiFormRecaptchaModal } from '@newswebsiteapp/shared/react/utils/useNmiFormRecaptchaModal'

const packageForm_initialState = {
  errorMessage: null,
  selectedPackages: {},
  purchaseNowButtonWasPressedAtLeastOnce: false,
  calculatedPriceCents: 0,
  inRealLifeTicketsBought: 0,
}

function packageForm_handlePurchaseNow({ packageForm_updateState, dataFromServer, setModalOpen }) {
  packageForm_updateState((draft) => {
    const { calculatedPriceCents, inRealLifeTicketsBought, conferencePackagesQuantity } =
      calculatePackages({
        selectedPackages: draft.selectedPackages,
        packages: dataFromServer.conference_packages,
      })
    draft.purchaseNowButtonWasPressedAtLeastOnce = true
    draft.calculatedPriceCents = calculatedPriceCents
    draft.inRealLifeTicketsBought = inRealLifeTicketsBought
    draft.errorMessage = generateErrorMessage({
      conferencePackagesQuantity,
      inRealLifeTicketsBought,
      dataFromServer,
    })
    if (!draft.errorMessage) {
      setModalOpen(true) // hmm
    }
  })
}

function packageForm_handlePackageQuantity({ packageId, newQuantity, packageForm_updateState, dataFromServer }) {
  packageForm_updateState((draft) => {
    // console.log('packageForm_handlePackageQuantity', { packageId, newQuantity, draft: Immer.current(draft) })

    // doesnt work, it shows 0, then 2
    // but I hacked it using `min={state.selectedPackages.hasOwnProperty(conference_package.id) ? 0 : 1}`
    // if (newQuantity === 0 && !draft.selectedPackages.hasOwnProperty(packageId)) {
    //   draft.selectedPackages[packageId] = 1
    // } else {
    draft.selectedPackages[packageId] = newQuantity
    // }

    const { calculatedPriceCents, inRealLifeTicketsBought, conferencePackagesQuantity } =
      calculatePackages({
        selectedPackages: draft.selectedPackages,
        packages: dataFromServer.conference_packages,
      })

    draft.calculatedPriceCents = calculatedPriceCents
    draft.inRealLifeTicketsBought = inRealLifeTicketsBought
    draft.errorMessage = generateErrorMessage({
      conferencePackagesQuantity,
      inRealLifeTicketsBought,
      dataFromServer,
    })

    // console.log('packageForm_handlePackageQuantity end', { packageId, newQuantity, draft: Immer.current(draft) })
  })
}

export default function App({ recaptchaSiteKey, recaptchaSiteKey_disabled, dataFromServer, modalFields_note_show }) {
  // const lastValidDataRef_selectedPackages = React.useRef(null)

  const {
    // lastValidDataRef_formData,
    // lastValidDataRef_recaptchaToken,
    // recaptchaInstanceRef,
    // modalOpen,
    setModalOpen,
    // recaptchaToken,
    // setRecaptchaToken,
    // submittingFinalForm,
    // setSubmittingFinalForm,
    // formError,
    // setFormError,
    // control,
    // handleSubmit,
    // collectJS,
    // collectJs_handleTimeout,
  } = useNmiFormRecaptchaModal({ dataFromServer })

  // console.log({ recaptchaToken, submittingFinalForm })

  // React.useEffect((orderDetails) => {
  //   console.log('useEffect!!!!')
  //   packageForm_handlePackageQuantity({ packageId: dataFromServer.conference_packages[1].id, newQuantity: 2, packageForm_updateState, dataFromServer })
  //   packageForm_handlePurchaseNow({ packageForm_updateState, dataFromServer })
  //   console.log('useEffect end!!!!')
  // }, [])

  const [packageForm_state, packageForm_updateState] = useImmer(packageForm_initialState)
  // console.log('render:', packageForm_state)

  // onFieldInvalid: fieldName => console.log('onFieldInvalid: ', fieldName),
  // on error - onTimeout will be called

  // const collectJs_handleResponse = React.useCallback((response) => {
  //   const selectedPackages = lastValidDataRef_selectedPackages.current
  //   if (!selectedPackages) {
  //     throw new Error('selectedPackages is empty, possible, TODO use setTimeout?')
  //   }
  //   collectJs_handleResponse_implementation({
  //     url: '/api/conference/buy',
  //     response,
  //     lastValidDataRef_formData,
  //     lastValidDataRef_recaptchaToken,
  //     lastValidDataRef_selectedPackages,
  //     submittingFinalForm,
  //     /// ///
  //     setFormError,
  //     setSubmittingFinalForm,
  //     collectJS,
  //     recaptchaInstanceRef,
  //     setRecaptchaToken,
  //     recaptchaSiteKey_disabled,
  //     otherBodyData: {
  //       packages: selectedPackages,
  //     },
  //     onSuccess: () => setModalOpen(false),
  //     onError: () => {
  //       lastValidDataRef_selectedPackages.current = null
  //     },
  //   })
  // }, [collectJS])

  // const onSubmit = React.useCallback(
  //   (formData) => {
  //     useNmiFormRecaptchaModal_onSubmitPrepare({
  //       collectJS,
  //       setFormError,
  //       submittingFinalForm,
  //       setSubmittingFinalForm,
  //       recaptchaSiteKey_disabled,
  //       lastValidDataRef_formData,
  //       lastValidDataRef_recaptchaToken,
  //       recaptchaToken,
  //       formData,
  //       callback: () => {
  //         // packageForm_updateState :: (IO draft => Void) => Void
  //         // callback is executed asyncronously, lol
  //         packageForm_updateState((draft) => {
  //           lastValidDataRef_selectedPackages.current = R.filter(value => value > 0, Immer.current(draft.selectedPackages))
  //           // console.log('collectJS', collectJS)
  //           collectJS.startPaymentRequest()
  //           // NOTE: will continue in onResponse !!!
  //         })
  //       },
  //     })
  //   },
  //   [collectJS, submittingFinalForm, recaptchaToken],
  // )

  // console.log('recaptchaToken', recaptchaToken)

  return (
    <>
      <Packages
        dataFromServer={dataFromServer}
        state={packageForm_state}
        packageForm_updateState={packageForm_updateState}
        setModalOpen={setModalOpen}
        packageForm_handlePackageQuantity={packageForm_handlePackageQuantity}
        packageForm_handlePurchaseNow={packageForm_handlePurchaseNow}
      />

      {/*
      <ModalWithPaymentForm
        modalOpen={modalOpen}
        recaptchaSiteKey={recaptchaSiteKey}
        recaptchaSiteKey_disabled={recaptchaSiteKey_disabled}
        handleReaptchaSuccess={setRecaptchaToken}
        handleReaptchaErrorOrExpire={() => { lastValidDataRef_recaptchaToken.current = null; setRecaptchaToken(null) }}
        handleModalClose={() => setModalOpen(false)}
        control={control}
        submittingFinalForm={submittingFinalForm}
        formError={formError}
        onSubmit={handleSubmit(onSubmit)}
        collectJs_handleTimeout={collectJs_handleTimeout}
        collectJs_handleResponse={collectJs_handleResponse}
        setRecaptchaInstance={instance => { recaptchaInstanceRef.current = instance }}
        modalFields_email_disabled={!!R.path(['current_user', 'email'], dataFromServer)}
        modalFields_note_show={modalFields_note_show}
        required_address_fields={dataFromServer.required_address_fields}
      />
      */}
    </>
  )
}
